/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_OptionsInputs */



/**
* | output |
* | --- |
* | "Compare Options" |
*
* @param {Compare_Event_Groups_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_options = /** @type {((inputs?: Compare_Event_Groups_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comparer les options")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen vergleichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confronta le opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сравнить варианты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comparar opciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("比较选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプションを比較する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकल्पों की तुलना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comparar opções")
	return /** @type {LocalizedString} */ ("Compare Options")
});